module.exports = __webpack_public_path__ + "static/dark-3efa5c47b0a12be4d5e3f6188eae9c7b.jpg";